module.exports = __webpack_public_path__ + "img/Ecosystem services (ESS)-Impacts to ESS.0d766c6e.svg";